<template>
    <FormSection title="Referral Readiness" :application-id="referral?.application">
        <template #content>
            <div class="row px-2 my-2" v-if="!isApplicationPalliative">
                <div class="col-12 col-lg-10" v-if="referral && ReferralReadiness.length > 0">
                    <section class="w-100" v-for="readiness in ReferralReadiness">
                        <div class="form-check custom-checkbox mb-2">
                            <input
                                type="checkbox"
                                :id="`ReferralReadiness${readiness.value}`"
                                class="form-check-input"
                                :value="readiness.value"
                                name="referral-readiness"
                                v-model="referral.referralReadiness"
                            />
                            <label class="form-check-label" :for="`ReferralReadiness${readiness.value}`">
                                <span class="me-1">{{ readiness.name }}</span>
                            </label>
                        </div>
                        <template v-if="f2fValue === readiness.value && isF2fVisitObtained">
                            <div class="card pt-2 px-3 my-2">
                                <div class="form-check custom-checkbox mb-2">
                                    <input
                                        type="checkbox"
                                        id="CopyFromTransferringHospice"
                                        class="form-check-input"
                                        v-model="referral.isCopyObtained"
                                    />
                                    <label class="form-check-label" for="CopyFromTransferringHospice">
                                        <span class="me-1">Copy obtained from transferring Hospice</span>
                                    </label>
                                </div>
                                <template v-if="!referral.isCopyObtained">
                                    <div class="row g-0">
                                        <div class="form-group col-12 col-lg-4 pe-lg-2">
                                            <label for="completed-by"> Completed By </label>
                                            <input
                                                class="form-control"
                                                type="text"
                                                name="completed-by"
                                                v-model="referral.completedBy"
                                            />
                                        </div>
                                        <div class="form-group col-12 col-lg-4 pe-lg-2">
                                            <label for="completed-date">
                                                Completed Date
                                                <i
                                                    class="fa fa-exclamation-triangle text-danger"
                                                    v-tooltip="{ title: 'Please enter the referral date.' }"
                                                    v-if="!referral.referralDate"
                                                ></i>
                                                <a
                                                    else
                                                    tabindex="0"
                                                    href="javascript:void(0);"
                                                    role="button"
                                                    v-custom-popover="{
                                                        content: `A face-to-face visit may not be done more than 30 days
                                                prior to admission. If beyond 30 days, a new face-to-face should be
                                                completed.`,
                                                        className: 'info-popup'
                                                    }"
                                                >
                                                    <i class="fas fa-info-circle text-primary ms-1"></i>
                                                </a>
                                            </label>
                                            <DatePicker :options="datePickerOptions" :getDate="completedDateChanged">
                                                <div class="input-group date datepickerInput">
                                                    <input
                                                        name="completedDate"
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="MM/DD/YYYY"
                                                        :value="formatDateInput(referral.completedDate)"
                                                        :on-change="
                                                            (e: any) =>
                                                                completedDateChanged(e.target.value, e.target.name)
                                                        "
                                                        autocomplete="off"
                                                        :disabled="!referral?.referralDate"
                                                    />
                                                    <div class="input-group-addon input-group-append">
                                                        <div class="input-group-text">
                                                            <i class="fa fa-calendar"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </DatePicker>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </section>
                </div>
            </div>
            <div class="row px-2 my-2" v-else>
                <div class="col-12 offset-lg-1 col-lg-10" v-if="referral && PalliativeReferralReadiness.length > 0">
                    <section class="w-100" v-for="readiness in PalliativeReferralReadiness">
                        <div class="form-check custom-checkbox form-check-inline mb-2">
                            <input
                                type="checkbox"
                                :id="`ReferralReadiness${readiness.name}`"
                                class="form-check-input"
                                :value="readiness.value"
                                v-model="referral.palliativeReferralReadiness"
                            />
                            <label class="form-check-label" :for="`ReferralReadiness${readiness.name}`">
                                <span class="me-1">{{ readiness.name }}</span>
                            </label>
                        </div>
                        <template v-if="orderReceivedValue == readiness.value && isOrderReceived">
                            <div class="card py-2 px-3 my-2 row">
                                <div
                                    class="form-check custom-radio form-check-inline"
                                    v-for="careOrder in CareOrderOptions"
                                >
                                    <input
                                        type="radio"
                                        :id="`careOrder${careOrder.value}`"
                                        name="care-order"
                                        class="form-check-input"
                                        v-model="referral.palliativeCareOrderOptions"
                                        :value="careOrder.value"
                                    />
                                    <label class="form-check-label" :for="`careOrder${careOrder.value}`">
                                        {{ careOrder.name }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </section>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ReferralReadiness.ts"></script>
